export default "__VITE_ASSET__B8ztCCd7__"